<nav class="navbar navbar-expand-lg navbar-light" style="background-color: #f5573e!important;">
    <ul class="navbar-nav w-100 text-center">
        <li class="nav-item flex-fill">
            <a routerLink="/add-user" routerLinkActive="active" class="nav-link custom-tab"> <i
                    class="fa fa-user-plus mr-3"></i> Add New User</a>
        </li>
        <li class="nav-item flex-fill">
            <a routerLink="/user-list" routerLinkActive="active" class="nav-link custom-tab"> <i
                    class="fa fa-users mr-3"></i>User List</a>
        </li>
    </ul>
</nav>

<div class="container my-4">
    <div class="card shadow rounded">
        <div class="card-header text-white text-center">
            <h4 class="mb-0" style="font: 500 29px / 4px Roboto, sans-serif;">Vivek Team</h4>
        </div>
        <div class="card-body p-5">
            <div class="table-responsive">
                <table class="table table-hover table-bordered mb-0 text-center">
                    <thead class="text-white" style="background-color: #0086c1;">
                        <tr>
                            <th>Username</th>
                            <th>Password</th>
                            <th>Mobile Number</th>
                            <th>Role</th>
                            <th>Department</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of users">
                            <td>{{ user.name }}</td>
                            <td>{{ user.password }}</td>
                            <td>{{ user.mobile }}</td>
                            <td>{{ user.role }}</td>
                            <td>{{ user.department }}</td>
                            <td>
                                <button class="btn btn-sm btn-outline-success mr-2" (click)="updateUser(user)">
                                    <i class="fa fa-pencil"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="deleteUser(user.id)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>

                        <!-- Show message if no data -->
                        <tr *ngIf="users.length === 0">
                            <td colspan="5" class="text-muted py-3">No users found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>